var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledMuscles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Filled Muscles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5941 14.6382C15.5669 14.3636 15.5856 14.0846 15.5834 13.8075C15.5717 12.3338 15.5614 10.8601 15.5445 9.3866C15.5431 9.27026 15.6284 9.05216 15.3538 9.12147C14.6765 9.29228 14.1672 8.99967 13.6782 8.57889C12.4614 7.53159 11.0308 7.1136 9.43647 7.28974C8.0204 7.44618 6.82927 8.13197 5.70368 8.94387C5.45321 9.12439 5.21385 9.32002 4.96944 9.50873C4.94904 9.49489 4.92863 9.48112 4.90822 9.46729C4.94776 9.31031 4.98668 9.1532 5.02696 8.99642C5.26719 8.06079 5.21015 7.10455 5.23459 6.15337C5.2486 5.60926 5.3039 5.07221 5.57976 4.57846C5.71769 4.33161 5.87798 4.22366 6.17599 4.29357C6.71175 4.41928 7.25775 4.4866 7.81135 4.44516C8.42948 4.39886 8.71463 4.14264 8.79922 3.53362C8.81545 3.41668 8.87041 3.38316 8.96167 3.36273C9.57966 3.22445 9.83289 2.45565 9.51588 1.86665C9.26325 1.39724 8.99581 0.935016 8.71962 0.478646C8.49615 0.109413 8.15032 -0.0424437 7.71882 0.0101043C7.52997 0.033119 7.34032 0.061189 7.15612 0.106952C5.61141 0.490819 4.3893 1.3834 3.42837 2.59035C2.36265 3.92892 1.71704 5.50277 1.206 7.11307C0.714895 8.66057 0.516419 10.2721 0.40691 11.887C0.328718 13.0396 0.789921 13.72 1.86662 14.1745C2.38447 14.393 2.9271 14.5319 3.48299 14.6187C4.92674 14.8443 7.73282 15.5497 9.1885 15.594C11.6446 15.6688 12.7551 15.0219 15.2128 15.0111C15.4993 15.0099 15.6241 14.9415 15.5941 14.6382Z",
    fill: "#1B8828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledMuscles);
export default __webpack_public_path__ + "static/media/icon-filled-muscles.9bc7b374e228453ed84d6515f5661e04.svg";
export { ForwardRef as ReactComponent };